import { TextInput } from '@core/components/Inputs';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { Button, makeStyles, Typography } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  buttonSave: {
    backgroundColor: 'white',
    border: '1px solid #43a047',
    color: '#43a047',
    minWidth: 90,
    height: 36,
    marginLeft: 10,
    borderRadius: 5,
    textTransform: 'capitalize',
    transition: '0.4s',
    '&:hover': {
      background: '#43a047',
      color: 'white',
    },
  },
}));

const SelecionarButton = ({ children }) => {
  const classes = useStyles();
  return (
    <Button className={`${classes.buttonSave} `} variant="contained" component="span">
      <Typography>{children}</Typography>
    </Button>
  );
};

const AnexoUnico = ({
  id,
  name,
  placeholder,
  onFileChange,
  arquivo,
  label = '',
  accept = '',
  error,
  helperText,
  onBlur,
  touched,
  disabled,
  required,
}) => {
  const classes = useStyles();

  return (
    <>
      <input
        style={{ display: 'none' }}
        className={classes.input}
        id="button-file"
        multiple
        type="file"
        onChange={onFileChange}
        label={label}
        accept={accept}
        onClick={(event) => (event.target.value = null)}
      />
      <TextInput
        id={id}
        name={name}
        placeholder={placeholder}
        label={label}
        value={arquivo?.name}
        required={required}
        onBlur={onBlur}
        touched={touched}
        error={error}
        helperText={helperText}
        disabled={disabled}
        InputProps={{
          endAdornment: (
            <label htmlFor="button-file">
              {(permissaoUtils.parametro().editar ||
                permissaoUtils.ConciliacaoBancaria().editar ||
                permissaoUtils.contaPagar().editar ||
                permissaoUtils.contaReceber().editar) && (
                <SelecionarButton component="span">Selecionar</SelecionarButton>
              )}
            </label>
          ),
          readOnly: true,
        }}
      />
    </>
  );
};

export default AnexoUnico;
